export default {
  setAttr (state, payload) {
    state[payload.name] = payload.value
  }
}
